import { openCfFtpInfoCreatePopup } from 'data/cfFtpInfo/cfFtpInfo.actions';
import { getCfFtpInfoCreatedId } from 'data/cfFtpInfo/cfFtpInfo.selectors';
import { CfFtpInfo } from 'data/cfFtpInfo/cfFtpInfo.types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldUpdateHandlerParam } from 'shared/form';
import { CollectionFunctionFormFieldHandler } from '../components/CollectionFunctionForm';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNewCfFtpInfo(
  handleFieldUpdate: CollectionFunctionFormFieldHandler,
): [CollectionFunctionFormFieldHandler] {
  const idCreated = useSelector(getCfFtpInfoCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();
  const formSectionRef = useRef<'facilityInformation'>();
  const tabIdRef = useRef<string>();

  useEffect(() => {
    if (idCreated == null || paramRef.current == null) {
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = idCreated;
    // The value label may have been changed in the create dialog, so removing it to avoid confusion
    param.valueLabel = null;

    handleFieldUpdate(param, formSectionRef.current, tabIdRef.current);

  }, [idCreated]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFieldCreateNew: CollectionFunctionFormFieldHandler = (param, formSection, tabId) => {
    if (formSection !== 'facilityInformation') {
      return;
    }

    const cfFtpInfo: CfFtpInfo = {
      id: '',
      FTPID: param.valueLabel,
      IPADDR: '',
      PORT: '',
      USERNAME: '',
      USERPASSWD: '',
      DESTPATH: '',
      OPERATORID: '',
      FTPFILESIZE: '2048',
      FTPFILESEC: '60',
      FILEMODE: 'ALLINONE',
      FTPTYPE: 'FTP',
      OWNER: '',
      GROUP: '',
      ACCESS: ''
    };

    dispatch(openCfFtpInfoCreatePopup(cfFtpInfo));

    paramRef.current = param;
    formSectionRef.current = formSection;
    tabIdRef.current = tabId;
  };

  return [handleFieldCreateNew];
}
